import { render, staticRenderFns } from "./ElFlexWrapperBoxV2.vue?vue&type=template&id=07e5ad99"
import script from "./ElFlexWrapperBoxV2.vue?vue&type=script&lang=js"
export * from "./ElFlexWrapperBoxV2.vue?vue&type=script&lang=js"
import style0 from "./ElFlexWrapperBoxV2.vue?vue&type=style&index=0&id=07e5ad99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports